import React from "react";
import { inject, observer } from "mobx-react";
import CountUp from 'react-countup';

const CampaignInfo = (props) => {
  const { goalVal, progress, raised } = props.overlayStore;

  return (
    <div className="therm-container">
      <p className="therm-container__raised">
        $<CountUp
          end={raised}
          duration={1}
          separator=","
          decimals={2}
          // prefix = "$"
          // suffix = " Raised"
          preserveValue={true}
          useEasing={false}
        /> Raised
      </p>
      <div
        className=
        {`
              ${progress <= 0
            ? "therm-container__inner no-point"
            : "therm-container__inner point"
          }
            `}
        style={{
          width: `
                ${progress}%
              `
        }}
      ></div>
      <p className="therm-container__goal">
        Goal: ${goalVal}
      </p>
    </div>
  );
}

export default inject("overlayStore")(observer(CampaignInfo));
